var _slicedToArray = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/toConsumableArray");

// Query Compiler
// -------
var helpers = require('../helpers');

var Raw = require('../raw');

var JoinClause = require('./joinclause');

var debug = require('debug');

var _require = require('lodash'),
    assign = _require.assign,
    bind = _require.bind,
    compact = _require.compact,
    groupBy = _require.groupBy,
    isEmpty = _require.isEmpty,
    isString = _require.isString,
    isUndefined = _require.isUndefined,
    map = _require.map,
    omitBy = _require.omitBy,
    reduce = _require.reduce,
    has = _require.has,
    keys = _require.keys;

var uuid = require('uuid');

var debugBindings = debug('knex:bindings'); // The "QueryCompiler" takes all of the query statements which
// have been gathered in the "QueryBuilder" and turns them into a
// properly formatted / bound query string.

function QueryCompiler(client, builder) {
  this.client = client;
  this.method = builder._method || 'select';
  this.options = builder._options;
  this.single = builder._single;
  this.timeout = builder._timeout || false;
  this.cancelOnTimeout = builder._cancelOnTimeout || false;
  this.grouped = groupBy(builder._statements, 'grouping');
  this.formatter = client.formatter(builder);
}

var components = ['columns', 'join', 'where', 'union', 'group', 'having', 'order', 'limit', 'offset', 'lock', 'waitMode'];
assign(QueryCompiler.prototype, {
  // Used when the insert call is empty.
  _emptyInsertValue: 'default values',
  // Collapse the builder into a single object
  toSQL: function toSQL(method, tz) {
    var _this = this;

    this._undefinedInWhereClause = false;
    this.undefinedBindingsInfo = [];
    method = method || this.method;
    var val = this[method]() || '';
    var query = {
      method: method,
      options: reduce(this.options, assign, {}),
      timeout: this.timeout,
      cancelOnTimeout: this.cancelOnTimeout,
      bindings: this.formatter.bindings || [],
      __knexQueryUid: uuid.v4()
    };
    Object.defineProperties(query, {
      toNative: {
        value: function value() {
          return {
            sql: _this.client.positionBindings(query.sql),
            bindings: _this.client.prepBindings(query.bindings)
          };
        },
        enumerable: false
      }
    });

    if (isString(val)) {
      query.sql = val;
    } else {
      assign(query, val);
    }

    if (method === 'select' || method === 'first') {
      if (this.single.as) {
        query.as = this.single.as;
      }
    }

    if (this._undefinedInWhereClause) {
      debugBindings(query.bindings);
      throw new Error("Undefined binding(s) detected when compiling " + "".concat(method.toUpperCase(), ". Undefined column(s): [").concat(this.undefinedBindingsInfo.join(', '), "] query: ").concat(query.sql));
    }

    return query;
  },
  // Compiles the `select` statement, or nested sub-selects by calling each of
  // the component compilers, trimming out the empties, and returning a
  // generated query string.
  select: function select() {
    var _this2 = this;

    var sql = this.with();
    var statements = components.map(function (component) {
      return _this2[component](_this2);
    });
    sql += compact(statements).join(' ');
    return sql;
  },
  pluck: function pluck() {
    var toPluck = this.single.pluck;

    if (toPluck.indexOf('.') !== -1) {
      toPluck = toPluck.split('.').slice(-1)[0];
    }

    return {
      sql: this.select(),
      pluck: toPluck
    };
  },
  // Compiles an "insert" query, allowing for multiple
  // inserts using a single query statement.
  insert: function insert() {
    var insertValues = this.single.insert || [];
    var sql = this.with() + "insert into ".concat(this.tableName, " ");

    if (Array.isArray(insertValues)) {
      if (insertValues.length === 0) {
        return '';
      }
    } else if (typeof insertValues === 'object' && isEmpty(insertValues)) {
      return sql + this._emptyInsertValue;
    }

    var insertData = this._prepInsert(insertValues);

    if (typeof insertData === 'string') {
      sql += insertData;
    } else {
      if (insertData.columns.length) {
        sql += "(".concat(this.formatter.columnize(insertData.columns));
        sql += ') values (';
        var i = -1;

        while (++i < insertData.values.length) {
          if (i !== 0) sql += '), (';
          sql += this.formatter.parameterize(insertData.values[i], this.client.valueForUndefined);
        }

        sql += ')';
      } else if (insertValues.length === 1 && insertValues[0]) {
        sql += this._emptyInsertValue;
      } else {
        sql = '';
      }
    }

    return sql;
  },
  // Compiles the "update" query.
  update: function update() {
    // Make sure tableName is processed by the formatter first.
    var withSQL = this.with();
    var tableName = this.tableName;

    var updateData = this._prepUpdate(this.single.update);

    var wheres = this.where();
    return withSQL + "update ".concat(this.single.only ? 'only ' : '').concat(tableName) + ' set ' + updateData.join(', ') + (wheres ? " ".concat(wheres) : '');
  },
  // Compiles the columns in the query, specifying if an item was distinct.
  columns: function columns() {
    var distinct = false;
    if (this.onlyUnions()) return '';
    var columns = this.grouped.columns || [];
    var i = -1,
        sql = [];

    if (columns) {
      while (++i < columns.length) {
        var stmt = columns[i];
        if (stmt.distinct) distinct = true;

        if (stmt.type === 'aggregate') {
          var _sql;

          (_sql = sql).push.apply(_sql, _toConsumableArray(this.aggregate(stmt)));
        } else if (stmt.type === 'aggregateRaw') {
          sql.push(this.aggregateRaw(stmt));
        } else if (stmt.value && stmt.value.length > 0) {
          sql.push(this.formatter.columnize(stmt.value));
        }
      }
    }

    if (sql.length === 0) sql = ['*'];
    return "select ".concat(distinct ? 'distinct ' : '') + sql.join(', ') + (this.tableName ? " from ".concat(this.single.only ? 'only ' : '').concat(this.tableName) : '');
  },
  _aggregate: function _aggregate(stmt) {
    var _this3 = this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$aliasSeparator = _ref.aliasSeparator,
        aliasSeparator = _ref$aliasSeparator === void 0 ? ' as ' : _ref$aliasSeparator,
        distinctParentheses = _ref.distinctParentheses;

    var value = stmt.value;
    var method = stmt.method;
    var distinct = stmt.aggregateDistinct ? 'distinct ' : '';

    var wrap = function wrap(identifier) {
      return _this3.formatter.wrap(identifier);
    };

    var addAlias = function addAlias(value, alias) {
      if (alias) {
        return value + aliasSeparator + wrap(alias);
      }

      return value;
    };

    var aggregateArray = function aggregateArray(value, alias) {
      var columns = value.map(wrap).join(', ');

      if (distinct) {
        var openParen = distinctParentheses ? '(' : ' ';
        var closeParen = distinctParentheses ? ')' : '';
        columns = distinct.trim() + openParen + columns + closeParen;
      }

      var aggregated = "".concat(method, "(").concat(columns, ")");
      return addAlias(aggregated, alias);
    };

    var aggregateString = function aggregateString(value, alias) {
      var aggregated = "".concat(method, "(").concat(distinct + wrap(value), ")");
      return addAlias(aggregated, alias);
    };

    if (Array.isArray(value)) {
      return [aggregateArray(value)];
    }

    if (typeof value === 'object') {
      if (stmt.alias) {
        throw new Error('When using an object explicit alias can not be used');
      }

      return Object.entries(value).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            alias = _ref3[0],
            column = _ref3[1];

        if (Array.isArray(column)) {
          return aggregateArray(column, alias);
        }

        return aggregateString(column, alias);
      });
    } // Allows us to speciy an alias for the aggregate types.


    var splitOn = value.toLowerCase().indexOf(' as ');
    var column = value;
    var alias = stmt.alias;

    if (splitOn !== -1) {
      column = value.slice(0, splitOn);

      if (alias) {
        throw new Error("Found multiple aliases for same column: ".concat(column));
      }

      alias = value.slice(splitOn + 4);
    }

    return [aggregateString(column, alias)];
  },
  aggregate: function aggregate(stmt) {
    return this._aggregate(stmt);
  },
  aggregateRaw: function aggregateRaw(stmt) {
    var distinct = stmt.aggregateDistinct ? 'distinct ' : '';
    return "".concat(stmt.method, "(").concat(distinct + this.formatter.unwrapRaw(stmt.value), ")");
  },
  // Compiles all each of the `join` clauses on the query,
  // including any nested join queries.
  join: function join() {
    var sql = '';
    var i = -1;
    var joins = this.grouped.join;
    if (!joins) return '';

    while (++i < joins.length) {
      var join = joins[i];
      var table = join.schema ? "".concat(join.schema, ".").concat(join.table) : join.table;
      if (i > 0) sql += ' ';

      if (join.joinType === 'raw') {
        sql += this.formatter.unwrapRaw(join.table);
      } else {
        sql += join.joinType + ' join ' + this.formatter.wrap(table);
        var ii = -1;

        while (++ii < join.clauses.length) {
          var clause = join.clauses[ii];

          if (ii > 0) {
            sql += " ".concat(clause.bool, " ");
          } else {
            sql += " ".concat(clause.type === 'onUsing' ? 'using' : 'on', " ");
          }

          var val = this[clause.type].call(this, clause);

          if (val) {
            sql += val;
          }
        }
      }
    }

    return sql;
  },
  onBetween: function onBetween(statement) {
    return this.formatter.wrap(statement.column) + ' ' + this._not(statement, 'between') + ' ' + map(statement.value, bind(this.formatter.parameter, this.formatter)).join(' and ');
  },
  onNull: function onNull(statement) {
    return this.formatter.wrap(statement.column) + ' is ' + this._not(statement, 'null');
  },
  onExists: function onExists(statement) {
    return this._not(statement, 'exists') + ' (' + this.formatter.rawOrFn(statement.value) + ')';
  },
  onIn: function onIn(statement) {
    if (Array.isArray(statement.column)) return this.multiOnIn(statement);
    return this.formatter.wrap(statement.column) + ' ' + this._not(statement, 'in ') + this.wrap(this.formatter.parameterize(statement.value));
  },
  multiOnIn: function multiOnIn(statement) {
    var i = -1,
        sql = "(".concat(this.formatter.columnize(statement.column), ") ");
    sql += this._not(statement, 'in ') + '((';

    while (++i < statement.value.length) {
      if (i !== 0) sql += '),(';
      sql += this.formatter.parameterize(statement.value[i]);
    }

    return sql + '))';
  },
  // Compiles all `where` statements on the query.
  where: function where() {
    var wheres = this.grouped.where;
    if (!wheres) return;
    var sql = [];
    var i = -1;

    while (++i < wheres.length) {
      var stmt = wheres[i];

      if (Object.prototype.hasOwnProperty.call(stmt, 'value') && helpers.containsUndefined(stmt.value)) {
        this.undefinedBindingsInfo.push(stmt.column);
        this._undefinedInWhereClause = true;
      }

      var val = this[stmt.type](stmt);

      if (val) {
        if (sql.length === 0) {
          sql[0] = 'where';
        } else {
          sql.push(stmt.bool);
        }

        sql.push(val);
      }
    }

    return sql.length > 1 ? sql.join(' ') : '';
  },
  group: function group() {
    return this._groupsOrders('group');
  },
  order: function order() {
    return this._groupsOrders('order');
  },
  // Compiles the `having` statements.
  having: function having() {
    var havings = this.grouped.having;
    if (!havings) return '';
    var sql = ['having'];

    for (var i = 0, l = havings.length; i < l; i++) {
      var s = havings[i];
      var val = this[s.type](s);

      if (val) {
        if (sql.length === 0) {
          sql[0] = 'where';
        }

        if (sql.length > 1 || sql.length === 1 && sql[0] !== 'having') {
          sql.push(s.bool);
        }

        sql.push(val);
      }
    }

    return sql.length > 1 ? sql.join(' ') : '';
  },
  havingRaw: function havingRaw(statement) {
    return this._not(statement, '') + this.formatter.unwrapRaw(statement.value);
  },
  havingWrapped: function havingWrapped(statement) {
    var val = this.formatter.rawOrFn(statement.value, 'where');
    return val && this._not(statement, '') + '(' + val.slice(6) + ')' || '';
  },
  havingBasic: function havingBasic(statement) {
    return this._not(statement, '') + this.formatter.wrap(statement.column) + ' ' + this.formatter.operator(statement.operator) + ' ' + this.formatter.parameter(statement.value);
  },
  havingNull: function havingNull(statement) {
    return this.formatter.wrap(statement.column) + ' is ' + this._not(statement, 'null');
  },
  havingExists: function havingExists(statement) {
    return this._not(statement, 'exists') + ' (' + this.formatter.rawOrFn(statement.value) + ')';
  },
  havingBetween: function havingBetween(statement) {
    return this.formatter.wrap(statement.column) + ' ' + this._not(statement, 'between') + ' ' + map(statement.value, bind(this.formatter.parameter, this.formatter)).join(' and ');
  },
  havingIn: function havingIn(statement) {
    if (Array.isArray(statement.column)) return this.multiHavingIn(statement);
    return this.formatter.wrap(statement.column) + ' ' + this._not(statement, 'in ') + this.wrap(this.formatter.parameterize(statement.value));
  },
  multiHavingIn: function multiHavingIn(statement) {
    var i = -1,
        sql = "(".concat(this.formatter.columnize(statement.column), ") ");
    sql += this._not(statement, 'in ') + '((';

    while (++i < statement.value.length) {
      if (i !== 0) sql += '),(';
      sql += this.formatter.parameterize(statement.value[i]);
    }

    return sql + '))';
  },
  // Compile the "union" queries attached to the main query.
  union: function union() {
    var onlyUnions = this.onlyUnions();
    var unions = this.grouped.union;
    if (!unions) return '';
    var sql = '';

    for (var i = 0, l = unions.length; i < l; i++) {
      var union = unions[i];
      if (i > 0) sql += ' ';
      if (i > 0 || !onlyUnions) sql += union.clause + ' ';
      var statement = this.formatter.rawOrFn(union.value);

      if (statement) {
        if (union.wrap) sql += '(';
        sql += statement;
        if (union.wrap) sql += ')';
      }
    }

    return sql;
  },
  // If we haven't specified any columns or a `tableName`, we're assuming this
  // is only being used for unions.
  onlyUnions: function onlyUnions() {
    return !this.grouped.columns && this.grouped.union && !this.tableName;
  },
  limit: function limit() {
    var noLimit = !this.single.limit && this.single.limit !== 0;
    if (noLimit) return '';
    return "limit ".concat(this.formatter.parameter(this.single.limit));
  },
  offset: function offset() {
    if (!this.single.offset) return '';
    return "offset ".concat(this.formatter.parameter(this.single.offset));
  },
  // Compiles a `delete` query.
  del: function del() {
    // Make sure tableName is processed by the formatter first.
    var tableName = this.tableName;
    var withSQL = this.with();
    var wheres = this.where();
    return withSQL + "delete from ".concat(this.single.only ? 'only ' : '').concat(tableName) + (wheres ? " ".concat(wheres) : '');
  },
  // Compiles a `truncate` query.
  truncate: function truncate() {
    return "truncate ".concat(this.tableName);
  },
  // Compiles the "locks".
  lock: function lock() {
    if (this.single.lock) {
      return this[this.single.lock]();
    }
  },
  // Compiles the wait mode on the locks.
  waitMode: function waitMode() {
    if (this.single.waitMode) {
      return this[this.single.waitMode]();
    }
  },
  // Fail on unsupported databases
  skipLocked: function skipLocked() {
    throw new Error('.skipLocked() is currently only supported on MySQL 8.0+ and PostgreSQL 9.5+');
  },
  // Fail on unsupported databases
  noWait: function noWait() {
    throw new Error('.noWait() is currently only supported on MySQL 8.0+, MariaDB 10.3.0+ and PostgreSQL 9.5+');
  },
  // On Clause
  // ------
  onWrapped: function onWrapped(clause) {
    var self = this;
    var wrapJoin = new JoinClause();
    clause.value.call(wrapJoin, wrapJoin);
    var sql = '';
    wrapJoin.clauses.forEach(function (wrapClause, ii) {
      if (ii > 0) {
        sql += " ".concat(wrapClause.bool, " ");
      }

      var val = self[wrapClause.type](wrapClause);

      if (val) {
        sql += val;
      }
    });

    if (sql.length) {
      return "(".concat(sql, ")");
    }

    return '';
  },
  onBasic: function onBasic(clause) {
    return this.formatter.wrap(clause.column) + ' ' + this.formatter.operator(clause.operator) + ' ' + this.formatter.wrap(clause.value);
  },
  onVal: function onVal(clause) {
    return this.formatter.wrap(clause.column) + ' ' + this.formatter.operator(clause.operator) + ' ' + this.formatter.parameter(clause.value);
  },
  onRaw: function onRaw(clause) {
    return this.formatter.unwrapRaw(clause.value);
  },
  onUsing: function onUsing(clause) {
    return '(' + this.formatter.columnize(clause.column) + ')';
  },
  // Where Clause
  // ------
  whereIn: function whereIn(statement) {
    var columns = null;

    if (Array.isArray(statement.column)) {
      columns = "(".concat(this.formatter.columnize(statement.column), ")");
    } else {
      columns = this.formatter.wrap(statement.column);
    }

    var values = this.formatter.values(statement.value);
    return "".concat(columns, " ").concat(this._not(statement, 'in ')).concat(values);
  },
  whereNull: function whereNull(statement) {
    return this.formatter.wrap(statement.column) + ' is ' + this._not(statement, 'null');
  },
  // Compiles a basic "where" clause.
  whereBasic: function whereBasic(statement) {
    return this._not(statement, '') + this.formatter.wrap(statement.column) + ' ' + this.formatter.operator(statement.operator) + ' ' + (statement.asColumn ? this.formatter.wrap(statement.value) : this.formatter.parameter(statement.value));
  },
  whereExists: function whereExists(statement) {
    return this._not(statement, 'exists') + ' (' + this.formatter.rawOrFn(statement.value) + ')';
  },
  whereWrapped: function whereWrapped(statement) {
    var val = this.formatter.rawOrFn(statement.value, 'where');
    return val && this._not(statement, '') + '(' + val.slice(6) + ')' || '';
  },
  whereBetween: function whereBetween(statement) {
    return this.formatter.wrap(statement.column) + ' ' + this._not(statement, 'between') + ' ' + map(statement.value, bind(this.formatter.parameter, this.formatter)).join(' and ');
  },
  // Compiles a "whereRaw" query.
  whereRaw: function whereRaw(statement) {
    return this._not(statement, '') + this.formatter.unwrapRaw(statement.value);
  },
  wrap: function wrap(str) {
    if (str.charAt(0) !== '(') return "(".concat(str, ")");
    return str;
  },
  // Compiles all `with` statements on the query.
  with: function _with() {
    if (!this.grouped.with || !this.grouped.with.length) {
      return '';
    }

    var withs = this.grouped.with;
    if (!withs) return;
    var sql = [];
    var i = -1;
    var isRecursive = false;

    while (++i < withs.length) {
      var stmt = withs[i];

      if (stmt.recursive) {
        isRecursive = true;
      }

      var val = this[stmt.type](stmt);
      sql.push(val);
    }

    return "with ".concat(isRecursive ? 'recursive ' : '').concat(sql.join(', '), " ");
  },
  withWrapped: function withWrapped(statement) {
    var val = this.formatter.rawOrFn(statement.value);
    return val && this.formatter.columnize(statement.alias) + ' as (' + val + ')' || '';
  },
  // Determines whether to add a "not" prefix to the where clause.
  _not: function _not(statement, str) {
    if (statement.not) return "not ".concat(str);
    return str;
  },
  _prepInsert: function _prepInsert(data) {
    var isRaw = this.formatter.rawOrFn(data);
    if (isRaw) return isRaw;
    var columns = [];
    var values = [];
    if (!Array.isArray(data)) data = data ? [data] : [];
    var i = -1;

    while (++i < data.length) {
      if (data[i] == null) break;
      if (i === 0) columns = Object.keys(data[i]).sort();
      var row = new Array(columns.length);

      var _keys = Object.keys(data[i]);

      var j = -1;

      while (++j < _keys.length) {
        var key = _keys[j];
        var idx = columns.indexOf(key);

        if (idx === -1) {
          columns = columns.concat(key).sort();
          idx = columns.indexOf(key);
          var k = -1;

          while (++k < values.length) {
            values[k].splice(idx, 0, undefined);
          }

          row.splice(idx, 0, undefined);
        }

        row[idx] = data[i][key];
      }

      values.push(row);
    }

    return {
      columns: columns,
      values: values
    };
  },
  // "Preps" the update.
  _prepUpdate: function _prepUpdate() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _this$single$counter = this.single.counter,
        counter = _this$single$counter === void 0 ? {} : _this$single$counter;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = keys(counter)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var column = _step.value;

        //Skip?
        if (has(data, column)) {
          //Needed?
          this.client.logger.warn("increment/decrement called for a column that has already been specified in main .update() call. Ignoring increment/decrement and using value from .update() call.");
          continue;
        }

        var value = counter[column];
        var symbol = value < 0 ? '-' : '+';

        if (symbol === '-') {
          value = -value;
        }

        data[column] = this.client.raw("?? ".concat(symbol, " ?"), [column, value]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    data = omitBy(data, isUndefined);
    var vals = [];
    var columns = Object.keys(data);
    var i = -1;

    while (++i < columns.length) {
      vals.push(this.formatter.wrap(columns[i]) + ' = ' + this.formatter.parameter(data[columns[i]]));
    }

    if (isEmpty(vals)) {
      throw new Error(['Empty .update() call detected!', 'Update data does not contain any values to update.', 'This will result in a faulty query.'].join(' '));
    }

    return vals;
  },
  // Compiles the `order by` statements.
  _groupsOrders: function _groupsOrders(type) {
    var items = this.grouped[type];
    if (!items) return '';
    var formatter = this.formatter;
    var sql = items.map(function (item) {
      var column = item.value instanceof Raw ? formatter.unwrapRaw(item.value) : formatter.columnize(item.value);
      var direction = type === 'order' && item.type !== 'orderByRaw' ? " ".concat(formatter.direction(item.direction)) : '';
      return column + direction;
    });
    return sql.length ? type + ' by ' + sql.join(', ') : '';
  }
});
QueryCompiler.prototype.first = QueryCompiler.prototype.select; // Get the table name, wrapping it if necessary.
// Implemented as a property to prevent ordering issues as described in #704.

Object.defineProperty(QueryCompiler.prototype, 'tableName', {
  get: function get() {
    if (!this._tableName) {
      // Only call this.formatter.wrap() the first time this property is accessed.
      var tableName = this.single.table;
      var schemaName = this.single.schema;
      if (tableName && schemaName) tableName = "".concat(schemaName, ".").concat(tableName);
      this._tableName = tableName ? this.formatter.wrap(tableName) : '';
    }

    return this._tableName;
  }
});
module.exports = QueryCompiler;